module.exports = __webpack_public_path__ + "img/Automotive.34d94049.png";